"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon02Icon, Sun02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useTheme } from "next-themes";
import * as React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useClickSound } from "@/hooks/use-click-sound";
import { cn } from "@/lib/utils";
type ModeToggleProps = {
  className?: string;
};
export function ModeToggle(t0) {
  const $ = _c(29);
  const {
    className
  } = t0;
  const {
    setTheme,
    resolvedTheme
  } = useTheme();
  const [mounted, setMounted] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      volume: 0.2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const click = useClickSound(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[3] !== click || $[4] !== mounted || $[5] !== resolvedTheme || $[6] !== setTheme) {
    t4 = () => {
      if (!mounted) {
        return;
      }
      setTheme(resolvedTheme === "light" ? "dark" : "light");
      click();
    };
    $[3] = click;
    $[4] = mounted;
    $[5] = resolvedTheme;
    $[6] = setTheme;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const toggleTheme = t4;
  const nextThemeLabel = resolvedTheme === "light" ? "Switch to dark mode" : "Switch to light mode";
  const t5 = mounted ? nextThemeLabel : "Toggle theme";
  let t6;
  if ($[8] !== className) {
    t6 = cn("relative flex items-center justify-center rounded-full bg-secondary/50 p-2.5 text-muted-foreground transition-colors duration-300 hover:bg-secondary hover:text-foreground", className);
    $[8] = className;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = mounted ? "rotate-0 scale-100 dark:-rotate-90 dark:scale-0" : "opacity-0";
  let t8;
  if ($[10] !== t7) {
    t8 = cn("transition-all duration-300", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <HugeiconsIcon icon={Sun02Icon} size={20} strokeWidth={1.5} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <div className={t8}>{t9}</div>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = mounted ? "rotate-90 scale-0 dark:rotate-0 dark:scale-100" : "opacity-0";
  let t12;
  if ($[15] !== t11) {
    t12 = cn("absolute inset-0 flex items-center justify-center transition-all duration-300", t11);
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HugeiconsIcon icon={Moon02Icon} size={20} strokeWidth={1.5} />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <div className={t12}>{t13}</div>;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t10 || $[21] !== t14 || $[22] !== t5 || $[23] !== t6 || $[24] !== toggleTheme) {
    t15 = <TooltipTrigger asChild={true}><button type="button" aria-label={t5} className={t6} onClick={toggleTheme}>{t10}{t14}</button></TooltipTrigger>;
    $[20] = t10;
    $[21] = t14;
    $[22] = t5;
    $[23] = t6;
    $[24] = toggleTheme;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <TooltipContent className="font-jakarta"><p>Toggle Theme</p></TooltipContent>;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15) {
    t17 = <Tooltip>{t15}{t16}</Tooltip>;
    $[27] = t15;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
}
export default ModeToggle;